export const SMART_REVIEW_TABS = {
  DEFAULT: "default",
  BANK_TRANSFER: "bank_transfer",
  UNMATCHED_VENDORS: "unmatched_vendor",
  UNCATEGORISED: "uncategorised",
} as const;

export type SmartReviewTabKey =
  (typeof SMART_REVIEW_TABS)[keyof typeof SMART_REVIEW_TABS];

export const SMART_REVIEW_TAB_LABELS: Record<SmartReviewTabKey, string> = {
  [SMART_REVIEW_TABS.DEFAULT]: "Smart Review",
  [SMART_REVIEW_TABS.BANK_TRANSFER]: "Bank Transfer",
  [SMART_REVIEW_TABS.UNMATCHED_VENDORS]: "Unmatched Vendor",
  [SMART_REVIEW_TABS.UNCATEGORISED]: "Uncategorised",
};

export const SMART_REVIEW_VENDOR_TABS = [
  SMART_REVIEW_TABS.DEFAULT,
  SMART_REVIEW_TABS.UNMATCHED_VENDORS,
  SMART_REVIEW_TABS.UNCATEGORISED,
] as const;

export type SmartReviewVendorTabKey = (typeof SMART_REVIEW_VENDOR_TABS)[number];
